import * as R from 'ramda';
const Model = ({
  model,
  filter,
  selecteds,
  handleSelect,
  handleDeselect,
  toggleSelectSize,
  sizeSelected,
}) => {
  const getFilteredModel = () => {
    const subs = model.subs ?? [];
    if (filter === 1) return subs;
    return R.filter(
      (item) =>
        (filter === 2 && item.is_prevention === 1) ||
        (filter === 3 && item.is_fire === 1),
      subs
    );
  };
  const onToggleModel = (e) => {
    const subs = getFilteredModel();
    if (e.target.checked) {
      handleSelect(
        model.id,
        R.map((item) => item.id, subs)
      );
    } else {
      handleDeselect(
        R.map((item) => item.id, subs),
        model.id
      );
    }
  };
  const onToggleSub = (e, id) => {
    if (e.target.checked) {
      handleSelect(model.id, [id]);
    } else {
      handleDeselect([id]);
    }
  };
  const selected = () => {
    return R.includes(model.id, selecteds);
  };
  const isSizeSelected = (mid, type) => {
    const sl = sizeSelected[mid];
    if (sl) {
      return R.includes(type, sl);
    }
    return false;
  };
  const getVisible = () => {
    return (
      (filter === 1 && model.is_standard === 1) ||
      (filter === 2 && model.is_prevention === 1) ||
      (filter === 3 && model.is_fire === 1)
    );
  };
  return (
    <div
      class='ac mt-0 bg-white border-none'
      style={getVisible() ? {} : { display: 'none' }}
    >
      <h2
        class='ac-header'
        style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
      >
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 20,
          }}
        >
          <input
            type='checkbox'
            class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
            checked={selected()}
            onChange={onToggleModel}
          />
        </div>
        <div
          type='button'
          class='ac-trigger relative !flex w-full items-center justify-between gap-2 !font-nunito !font-semibold !text-dark after:!hidden'
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              columnGap: 10,
              alignItems: 'center',
            }}
          >
            <span class='leading-[22px]'>{model.name}</span>
          </div>
          <div class='leading-[22px]'>
            <i class='mdi mdi-plus plus text-xl font-bold leading-[0px]'></i>
            <i class='mdi mdi-minus minus text-xl font-bold leading-[0px]'></i>
          </div>
        </div>
      </h2>
      <div class='ac-panel'>
        {getFilteredModel().map((item) => (
          <p
            class='ac-text !p-[26px] !pt-[6px] !font-nunito !text-[15px] !font-normal !leading-[22px]'
            key={item.id}
          >
            <input
              type='checkbox'
              class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
              checked={R.includes(item.id, selecteds)}
              onChange={(e) => onToggleSub(e, item.id)}
            />
            <label class='ml-1 relative top-[2px]'>{item.name}</label>
            {(item.name === 'FCD' || item.name === 'BCD') && (
              <div>
                <p
                  class='ac-text !pt-[6px] !font-nunito !text-[15px] !font-normal !leading-[22px]'
                  key={`c-${item.id}`}
                  style={{ paddingLeft: 22, paddingTop: 20 }}
                >
                  <input
                    type='checkbox'
                    class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                    checked={isSizeSelected(item.id, 'C')}
                    onChange={(e) => {
                      if (
                        !isSizeSelected(item.id, 'C') &&
                        !R.includes(item.id, selecteds)
                      )
                        handleSelect(model.id, [item.id]);
                      toggleSelectSize(e, item.id, 'C');
                    }}
                  />
                  <label class='ml-1 relative top-[2px]'>C</label>
                </p>
                <p
                  class='ac-text !pt-[6px] !font-nunito !text-[15px] !font-normal !leading-[22px]'
                  key={`e-${item.id}`}
                  style={{ paddingLeft: 22 }}
                >
                  <input
                    type='checkbox'
                    class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                    checked={isSizeSelected(item.id, 'E')}
                    onChange={(e) => {
                      if (
                        !isSizeSelected(item.id, 'E') &&
                        !R.includes(item.id, selecteds)
                      )
                        handleSelect(model.id, [item.id]);
                      toggleSelectSize(e, item.id, 'E');
                    }}
                  />
                  <label class='ml-1 relative top-[2px]'>E</label>
                </p>
                <p
                  class='ac-text !pt-[6px] !font-nunito !text-[15px] !font-normal !leading-[22px]'
                  key={`r-${item.id}`}
                  style={{ paddingLeft: 22 }}
                >
                  <input
                    type='checkbox'
                    class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                    checked={isSizeSelected(item.id, 'R')}
                    onChange={(e) => {
                      if (
                        !isSizeSelected(item.id, 'R') &&
                        !R.includes(item.id, selecteds)
                      )
                        handleSelect(model.id, [item.id]);
                      toggleSelectSize(e, item.id, 'R');
                    }}
                  />
                  <label class='ml-1 relative top-[2px]'>R</label>
                </p>
              </div>
            )}
          </p>
        ))}
      </div>
    </div>
  );
};

export default Model;
